

import { interpolateSafe, PhraseMap } from '@ms/yammer-i18n';

export default class InterpolateStrings {

  public static feature: string = 'panes';

  private locale: string;
  private phrases: PhraseMap;

  constructor(locale: string, phrases: PhraseMap) {
    this.locale = locale;
    this.phrases = phrases;
  }

  public showNavigationPane(): string {
    return interpolateSafe(this.locale, this.phrases, 'showNavigationPane');
  }

  public showAdditionalInformationPane(): string {
    return interpolateSafe(this.locale, this.phrases, 'showAdditionalInformationPane');
  }

}
